export default __webpack_public_path__ + "static/media/Snore.b006569c.mp3";